import common from "../../utill/Common";

class UtiitslPANCardService {
  generateLoginUrl = async (token) => {
    const url = common.baseUrl + "user/utiitsl_pancard/generate_login_url";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: null,
    };

    const response = await fetch(url, options);

    return response.json();
  };

  /////////// NEW FUNCTION ////////////////
  panAppReq = async (token, panData) => {
    const url = common.baseUrl + "user/uti_pancard/v2/pan_app_req";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ panData: panData }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  objectionList = async (token) => {
    const url = common.baseUrl + "user/uti_pancard/v2/objection_list";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: null,
    };

    const response = await fetch(url, options);

    return response.json();
  };

  objectionEdit = async (token, coupon_no) => {
    const url = common.baseUrl + "user/uti_pancard/v2/objection_edit";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ coupon_no: coupon_no }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  pendingDoc = async (token) => {
    const url = common.baseUrl + "user/uti_pancard/v2/pending_doc";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: null,
    };

    const response = await fetch(url, options);

    return response.json();
  };

  objectionDoc = async (token) => {
    const url = common.baseUrl + "user/uti_pancard/v2/objection_doc";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: null,
    };

    const response = await fetch(url, options);

    return response.json();
  };

  pendingUpload = async (token, coupon_no) => {
    const url = common.baseUrl + "user/uti_pancard/v2/pending_upload";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ coupon_no: coupon_no }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  downloadForm = async (token, order_id) => {
    const url = common.baseUrl + "user/uti_pancard/v2/download_form";
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ order_id: order_id }),
    };

    try {
      const response = await fetch(url, options);

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to download PDF: ${errorText}`);
      }

      const blob = await response.blob();
      const pdfUrl = URL.createObjectURL(blob);

      // Open the PDF in a new tab
      window.open(pdfUrl, "_blank");
    } catch (err) {
      console.error("Error downloading form:", err);
    }
  };
  /////////// NEW FUNCTION ////////////////

  /////////// CR FUNCTION ////////////////

  crPanAppReq = async (token, panData) => {
    const url = common.baseUrl + "user/uti_pancard/v2/cr_pan_app_req";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ panData: panData }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  crObjectionList = async (token) => {
    const url = common.baseUrl + "user/uti_pancard/v2/cr_objection_list";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: null,
    };

    const response = await fetch(url, options);

    return response.json();
  };

  crObjectionEdit = async (token, coupon_no) => {
    const url = common.baseUrl + "user/uti_pancard/v2/cr_objection_edit";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ coupon_no: coupon_no }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  crPendingDoc = async (token) => {
    const url = common.baseUrl + "user/uti_pancard/v2/cr_pending_doc";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: null,
    };

    const response = await fetch(url, options);

    return response.json();
  };

  crObjectionDoc = async (token) => {
    const url = common.baseUrl + "user/uti_pancard/v2/cr_objection_doc";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: null,
    };

    const response = await fetch(url, options);

    return response.json();
  };

  crPendingUpload = async (token, coupon_no) => {
    const url = common.baseUrl + "user/uti_pancard/v2/cr_pending_upload";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ coupon_no: coupon_no }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  crDownloadForm = async (token, order_id) => {
    const url = common.baseUrl + "user/uti_pancard/v2/cr_download_form";
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ order_id: order_id }),
    };

    try {
      const response = await fetch(url, options);

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to download PDF: ${errorText}`);
      }

      const blob = await response.blob();
      const pdfUrl = URL.createObjectURL(blob);

      // Open the PDF in a new tab
      window.open(pdfUrl, "_blank");
    } catch (err) {
      console.error("Error downloading form:", err);
    }
  };

  crDownloadReceipt = async (token, order_id) => {
    const url = common.baseUrl + "user/uti_pancard/v2/cr_download_receipt";
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ order_id: order_id }),
    };

    try {
      const response = await fetch(url, options);

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to download PDF: ${errorText}`);
      }

      const blob = await response.blob();
      const pdfUrl = URL.createObjectURL(blob);

      // Open the PDF in a new tab
      window.open(pdfUrl, "_blank");
    } catch (err) {
      console.error("Error downloading form:", err);
    }
  };

  /////////// CR FUNCTION ////////////////

  utiV2Report = async (
    token,
    from_date,
    to_date,
    status,
    search_text,
    page,
    size
  ) => {
    const url = common.baseUrl + "user/uti_pancard/v2/report";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        from_date,
        to_date,
        status,
        search_text,
        page,
        size,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  fetchByOrderId = async (token, order_id) => {
    const url = common.baseUrl + "user/uti_pancard/v2/fetch_by_order_id";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ order_id: order_id }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  downloadReceipt = async (token, order_id) => {
    const url = common.baseUrl + "user/uti_pancard/v2/download_receipt";
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ order_id: order_id }),
    };

    try {
      const response = await fetch(url, options);

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to download PDF: ${errorText}`);
      }

      const blob = await response.blob();
      const pdfUrl = URL.createObjectURL(blob);

      // Open the PDF in a new tab
      window.open(pdfUrl, "_blank");
    } catch (err) {
      console.error("Error downloading form:", err);
    }
  };

  panFind = async (token, aadhaar) => {
    const url = common.baseUrl + "user/uti_pancard/pan_find";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ aadhaar: aadhaar }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  panFindReport = async (
    token,
    from_date,
    to_date,
    status,
    search_text,
    page,
    size
  ) => {
    const url = common.baseUrl + "user/uti_pancard/pan_find_report";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        from_date,
        to_date,
        status,
        search_text,
        page,
        size,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  fetchCommercial = async (token) => {
    const url = common.baseUrl + "user/uti_pancard/v2/fetch_commercial";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({}),
    };

    const response = await fetch(url, options);

    return response.json();
  };
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new UtiitslPANCardService();
